var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundImgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 551,
    height: 342,
    viewBox: "0 0 551 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 551,
    height: 342,
    rx: 13.8077,
    fill: "#F5F5FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5126_4506",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 551,
    height: 342
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 551,
    height: 342,
    rx: 13.8077,
    fill: "#F6F6FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5126_4506)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5126_4506)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.763,
    cy: 221.016,
    rx: 192.763,
    ry: 221.016,
    transform: "matrix(-0.86962 0.493722 -0.477752 -0.878495 861.867 127.02)",
    fill: "url(#paint0_angular_5126_4506)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5126_4506",
    x: 293.85,
    y: -284.904,
    width: 589.589,
    height: 625.866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 48.3269,
    result: "effect1_foregroundBlur_5126_4506"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_5126_4506",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.276 206.762) rotate(117.043) scale(197.16 183.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#DCE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#B3A9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundImgVideo);
export default __webpack_public_path__ + "static/media/background_img_video.2695100a085ee2e8bc1a46793a7e143a.svg";
export { ForwardRef as ReactComponent };